export default __webpack_public_path__ + "static/media/img13.1fcfb6da.png";